<template>
  <v-container v-bind="bind_container" >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-text style="padding-bottom: 8px;">
            <v-layout row wrap>
              <v-flex xs10>
                <ais-search-box>
                  <v-form @submit.prevent="search">
                    <ais-input inline-template>
                      <v-text-field
                        name="search"
                        label="Search"
                        id="searchInput"
                        v-model="query"
                        append-icon="search"
                        >
                      </v-text-field>
                    </ais-input>
                  </v-form>
                </ais-search-box>
              </v-flex>
              <v-flex xs2>
                <ais-clear/>
              </v-flex>
            </v-layout>

            <ais-pools attribute-name="Pools" operator="or" :allowEdit="false">
              <h3 slot="header" class="title primary--text mb-2">Bookmarks</h3>
            </ais-pools>
            <ais-refinement-list attribute-name="country" operator="and" :show-search-input="true">
              <h3 slot="header" class="title primary--text mb-2">Country</h3>
            </ais-refinement-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AisRefinementList from '../AisComponents/AisRefinementList'
import AisPools from '../AisComponents/AisPools'
import AisClear from '../AisComponents/AisClear'

export default {
  name: 'PoliciesSearchPanel',
  data () {
    return {
      panel: [(!this.$vuetify.breakpoint.mdAndDown), (!this.$vuetify.breakpoint.mdAndDown)]
    }
  },
  components: {
    AisRefinementList,
    AisPools,
    AisClear
  },
  computed: {
    bind_container () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = ' padding:0px;'
      return binding
    }
  }
}
</script>
<style>
</style>
